import { Auth } from 'aws-amplify';
import { history } from '../../history';
import * as resetActions from '../../actions/reset-password-actions/reset-password-actions';
import * as loginActions from '../../actions/login-actions/loginActions';
import axios from 'axios';

const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || 'https://apidmz.fpl.com';
// 'http://localhost:8080';

let authHeader =
  'Authorization, Origin, X-Requested-With, content-Type, Accept';
let REQUEST_TYPE = 'application/json';
let API_KEY = process.env.REACT_APP_RTCP_API_KEY;

export function resetPasswordVerifyUser(user) {
  console.log('resetPassword', user);

  return dispatch => {
    dispatch(loginActions.reset());
    dispatch(resetActions.removeError());
    dispatch(resetActions.setResetPending(true));
    axios
      .post(`${API_ENDPOINT}/v1/surety-bond/auth/verifyUser`, '', {
        headers: {
          'Content-Type': REQUEST_TYPE,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': authHeader,
          'Access-Control-Allow-Methods': '*',
          'Access-Control-Allow-Credentials': 'true',
          apikey: API_KEY,
          emailId: user,
        },
        crossorigin: true,
      })
      .then(response => {
        console.log('resetPasswordVerifyUser response', response);
        dispatch(resetActions.setVerifyUserSuccess(false, response.data));
      })
      .catch(error => {
        dispatch(
          resetActions.setResetPasswordError(
            false,
            error.response.data.message,
          ),
        );
      });
  };
}

export function resetPasswordUser(payload) {
  return dispatch => {
    dispatch(loginActions.reset());
    dispatch(resetActions.removeError());
    dispatch(resetActions.setResetPending(true));
    axios
      .post(`${API_ENDPOINT}/v1/surety-bond/auth/updatePassword`, payload, {
        headers: {
          'Content-Type': REQUEST_TYPE,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': authHeader,
          'Access-Control-Allow-Methods': '*',
          'Access-Control-Allow-Credentials': 'true',
          apikey: API_KEY,
        },
        crossorigin: true,
      })
      .then(response => {
        console.log(' resetPasswordUser response', response);
        dispatch(resetActions.setResetConfirmSuccess(false, response));
        history.push('/');
      })
      .catch(erro => {
        console.log(' resetPasswordUser error response', erro.response);
        dispatch(
          resetActions.setResetPasswordError(false, erro.response.data.message),
        );
      });
  };
}

export function resetPassword(user) {
  console.log('resetPassword', user);
  let username = user;
  return dispatch => {
    dispatch(loginActions.reset());
    dispatch(resetActions.removeError());
    dispatch(resetActions.setResetPending(true));
    console.log(Auth.verifyCurrentUserAttribute({ email: username }));
    Auth.forgotPassword(username)
      .then(response => {
        console.log('actions.logout():Auth.resetPassword data:', response);
        dispatch(resetActions.setResetSuccess(false, response));
      })
      .catch(error => {
        console.log('login error', error);
        dispatch(resetActions.setResetPasswordError(false, error.message));
      });
  };
}

export function resetPasswordConfirm(user, code, newPassword) {
  let username = user;
  return dispatch => {
    dispatch(loginActions.reset());
    dispatch(resetActions.removeError());
    dispatch(resetActions.setResetPending(true));
    Auth.forgotPasswordSubmit(username, code, newPassword)
      .then(response => {
        console.log('actions.logout() data:', response);
        dispatch(resetActions.setResetConfirmSuccess(false, response));
        history.push('/');
      })
      .catch(error => {
        console.log('login error', error);
        dispatch(resetActions.setResetPasswordError(false, error.message));
      });
  };
}

export function setNewPassword(oldPassword, newPassword, onSuccess) {
  return dispatch => {
    dispatch(loginActions.reset());
    dispatch(resetActions.removeError());
    dispatch(resetActions.setResetPending(true));
    Auth.currentAuthenticatedUser()
      .then(user => {
        return Auth.changePassword(user, oldPassword, newPassword)
          .then(response => {
            console.log('actions.changePassword data:', response);
            dispatch(
              resetActions.setNewPasswordSuccess(
                false,
                'Successfully updated the password',
              ),
            );
            onSuccess(false);
            //  history.push('/')
          })
          .catch(error => {
            console.log('New password error', error);
            dispatch(
              resetActions.setResetPasswordError(
                false,
                'Your password is incorrect. Please try again.',
              ),
            );
            onSuccess(true);
          });
      })
      .catch(error => {
        console.log('New password error', error);
        dispatch(
          resetActions.setResetPasswordError(
            false,
            'Please verify the current password',
          ),
        );
      });
  };
}

export function setNewCompany(payload, onSuccess) {
  let companyName = payload.companyName;
  let street = payload.street;
  let streetLine2 = payload.streetline2;
  let city = payload.city;
  let state = payload.state;
  let zipCode = payload.zipCode;
  let phoneNumber = payload.phoneNumber;
  let url = payload.url;
  return dispatch => {
    dispatch(resetActions.removeError());
    dispatch(resetActions.setResetPending(true));
    Auth.currentAuthenticatedUser()
      .then(user => {
        return Auth.updateUserAttributes(user, {
          'custom:companyName': companyName,
          'custom:street': street,
          'custom:streetLine2': streetLine2,
          'custom:city': city,
          'custom:state': state,
          'custom:zipCode': zipCode,
          'custom:phoneNumber': phoneNumber,
          'custom:companyWebSite': url,
        })
          .then(response => {
            console.log('actions.changePassword data:', response);
            Auth.currentAuthenticatedUser().then(currentAuthUser => {
              dispatch(
                loginActions.setLoginSuccess(
                  false,
                  currentAuthUser,
                  getCurrentUser(currentAuthUser.attributes),
                  currentAuthUser.signInUserSession.idToken.jwtToken,
                ),
              );
            });
            dispatch(
              resetActions.setNewPasswordSuccess(
                false,
                'Successfully updated the Company Details',
              ),
            );
            onSuccess(false);
            axios
              .post(`${API_ENDPOINT}/v1/surety-bond/agent/update`, '', {
                headers: {
                  'Content-Type': REQUEST_TYPE,
                  'Access-Control-Allow-Origin': '*',
                  'Access-Control-Allow-Headers': authHeader,
                  'Access-Control-Allow-Methods': '*',
                  'Access-Control-Allow-Credentials': 'true',
                  apikey: API_KEY,
                },
                crossorigin: true,
              })
              .then(response => {
                console.log('resetPasswordVerifyUser response', response);
              });
          })
          .catch(error => {
            console.log('New password update error', error);
            dispatch(resetActions.setResetPasswordError(false, error.message));
            onSuccess(true);
          });
      })
      .catch(error => {
        console.log('New password Authentication error', error);
        dispatch(
          resetActions.setResetPasswordError(
            false,
            'Please verify the current password',
          ),
        );
      });
  };
}

export const getCurrentUser = response => {
  return {
    emailAddress: response['email'],
    firstName: response['custom:firstName'],
    lastName: response['custom:lastName'],
    companyName: response['custom:companyName'],
    street: response['custom:street'],
    streetline2: response['custom:streetLine2'],
    city: response['custom:city'],
    state: response['custom:state'],
    zipCode: response['custom:zipCode'],
    phoneNumber: response['custom:phoneNumber'],
    companyWebSite: response['custom:companyWebSite'],
  };
};

export function cancelReset() {
  return dispatch => {
    dispatch(resetActions.setResetCancel());
  };
}
